<template>
    <b-card-code title="View Tree">

        <!-- toggle button -->
        <b-table-simple
                responsive
                class="mb-0"
              >
                <b-tbody>
                  <template v-for="(r_PrivilegeCategory, index) in PrivilegeTree">
                    <b-td>
                      <b-tr :value="r_PrivilegeCategory.privilege_category_id">{{ r_PrivilegeCategory.name }}</b-tr>
                    </b-td>
                  <b-tr v-bind:key="index">
                    <b-col>
                    <template v-for="(r_Privilege, index) in r_PrivilegeCategory.privilege">
                      <template v-if="r_Privilege.privilege_id === r_PrivilegeCategory.privilege_category_id">
                        <b-td v-bind:key="index">
                        <b-tr :value="r_Privilege.privilege_id"> {{ r_Privilege.privilege_name }} </b-tr>
                      </b-td>
                    </template>
                  </template>
                </b-col>
                  </b-tr>
                  <b-tr>
                    <template v-for="(r_Privilege_c, index) in r_PrivilegeCategory.privilege_category">
                    <template v-for="r_Privilege_c_p in r_Privilege_c.privilege">
                      <div class="ml-2">
                      <template v-if="r_Privilege_c.level === 2">
                        <b-td v-bind:key="index">
                        <b-tr :value="r_Privilege_c.privilege_category_id"> {{ r_Privilege_c.name }} </b-tr>
                      </b-td>
                    </template>
                  </div>
                  <div class="ml-3 col">
                      <template v-if="r_Privilege_c_p.privilege_id === r_Privilege_c.privilege_category_id">
                        <b-td>
                        <b-tr :value="r_Privilege_c_p.privilege_id"> {{ r_Privilege_c_p.privilege_name }} </b-tr>
                      </b-td>
                    </template>
                  </div>
                  <div class="ml-4 col">
                    <template v-for="r_Privilege_c_level in r_Privilege_c.privilege_category">
                    <template v-for="r_Privilege_c_level_p in r_Privilege_c_level.privilege">
                        <b-col>
                      <template v-if="r_Privilege_c_level.level === 4 || r_Privilege_c_level.level === 3">
                        <b-td>
                        <b-tr :value="r_Privilege_c_level.privilege_category_id"> {{ r_Privilege_c_level.name }} </b-tr>
                      </b-td>
                    </template>
                </b-col>
                <div class="ml-4">
                <template v-if="r_Privilege_c_level_p.privilege_id === r_Privilege_c_level.privilege_category_id ">
                    <b-td>
                    <b-tr :value="r_Privilege_c_level_p.privilege_id"> {{ r_Privilege_c_level_p.privilege_name }} </b-tr>
                  </b-td>
                </template>
            </div>
                </template>
                </template>
                  </div>
                    </template>
                    </template>
                  </b-tr>
                  </template>
                </b-tbody>
              </b-table-simple>
    </b-card-code>
</template>
  
<script>
import {
    BCollapse, BButton, VBToggle, BCard, BCardText, BRow, BThead, BTr, BTh, BTd, BTbody, BTableSimple, BTable, BOverlay, BCol, BCardHeader, BCardTitle
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import BCardCode from '@core/components/b-card-code'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'

export default {
    components: { BCardCode, BButton, BCardText, BCard, BCollapse, BRow, BThead, BTr, BTh, BTd, BTbody, BTableSimple, BTable, BOverlay, BCol, BCardHeader, BCardTitle },
    directives: {
        'b-toggle': VBToggle,
        Ripple,
    },
    computed: {
        ...mapState({
            PrivilegeTree: state => state.privilegeCategory.itemsTree
        })
    },
    created() {
        this.$store.dispatch('privilegeCategory/getAllTree')
    }
}
</script>
  